import Component from '@glimmer/component';
import { action } from '@ember/object';
import FunctionalUtils from 'mewe/shared/functional-utils.js';
import dispatcher from 'mewe/dispatcher';

export default class MwFollowPage extends Component {
  
  @action
  toggleFollow() {
    if (this.args.page.isOpenPage) return;
    dispatcher.dispatch('pages', 'toggleFollow', this.args.page, { setToFollow: !this.args.page.isFollower });
  }

  @action
  mainAction() {
    if (this.args.page.isOpenPage) {
      this.args.followAction();
      return;
    }
    if (!this.args.page.isFollower) {
      this.toggleFollow();
      FunctionalUtils.info(__('You are now following this page'));
      if (this.args.followAction) this.args.followAction();
    }
  }
}
